import { Guid } from 'Lib/Guid';
import WebApi from 'Lib/WebApi';

/** Spectra.QEST.Contracts.Models.AgsExport.AgsExportRevisionModel */
export interface IAgsExportRevision {
  Id: Guid;
  AgsExportId: Guid;
  StartDate?: Date;
  EndDate?: Date;
  IssueNumber: number;
  CreationDate: Date;
  Filename: string;
  FileSizeBytes: number;
  IsContentValid: boolean;
  AgsExportConfigurationName: string;
}

const buildAgsRevisionDownloadUri = (agsExportRevisionId: Guid) =>
  WebApi.ags.revision.content.buildUri({
    agsExportRevisionId,
  });

export { buildAgsRevisionDownloadUri };
